import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'

  import { onBeforeRouteLeave, useRoute } from 'vue-router/composables'
  import useEditor from '@/composables/useEditor'

  import { UserModule } from '@/store/modules/user'
  import { EditorModule } from '@/store/modules/editor'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyEditorLayout',
  setup(__props) {

  const route = useRoute()
  const { inEditorMode } = useEditor(route)

  onMounted(() => {
    if (UserModule.isCompanyEditor) {
      EditorModule.setEditMode(true)
    }
  })

  onBeforeRouteLeave((_to, _from, next) => {
    if (['CourseModule', 'Lesson'].includes(_to.name as string) && !inEditorMode.value) {
      EditorModule.setEditMode(true)
    } else {
      EditorModule.setEditMode(false)
    }
    next()
  })

return { __sfc: true,route, inEditorMode, onMounted, onBeforeRouteLeave, useRoute, useEditor, UserModule, EditorModule }
}

})